import { z } from "zod";

export const createDeparmentSchema = z
  .object({
    unidade_slug: z.string().min(1, "Unidade é obrigatória"),
    misto: z.boolean().default(false),
    setor_id: z
      .object({
        id: z.number(),
        nome: z.string(),
      })
      .optional()
      .nullable(),
    ativo: z.boolean().default(false),
  })
  .superRefine((data, ctx) => {
    if (!data.misto && !data.setor_id) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "O setor é obrigatório",
        path: ["setor_id"],
      });
    }
  });

export type CreateDepartmentSchemaData = z.infer<typeof createDeparmentSchema>;
